import { render, staticRenderFns } from "./LocaleSelector.vue?vue&type=template&id=7d29d92f&"
import script from "./LocaleSelector.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LocaleSelector.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports